import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import i18n from '../../../locale/i18n';

import { PageTitle } from '../../../components/common/PageTitle/PageTitle';
import { useResponsive } from '../../../hooks/useResponsive';
import * as S from '../Legal.styles';

const link = "/";

const DMCAPolicyPage: React.FC = (props: any) => {
    const { isDesktop } = useResponsive();
    const { t } = useTranslation();
  
    const desktopLayout = (
      <>
      <S.H1 level={1}>DMCA Policy</S.H1>
      <S.ContentRight>Last Updated: 15 June 2023</S.ContentRight>

      <S.Paragraph>We take the intellectual and proprietary rights of others seriously and require that our users do the same. The Digital Millennium Copyright Act (DMCA) established a process for addressing claims of copyright infringement.</S.Paragraph>
      <S.Paragraph>If you own a copyright or have authority to act on behalf of a copyright owner and you believe that your copyrighted works or materials are improperly posted, displayed or accessible on any website that is owned or controlled by us, please send a notice that meets the minimum requirements of the DMCA, listed below, to 
      <a href="mailto:dmca@omrquiz.com" rel="alternate">&nbsp;dmca@omrquiz.com</a>
      . Please note that we are a 
      <S.TextLink to={{ pathname: link + '/legal/paperless-policy' }}>
      &nbsp;paperless
      </S.TextLink> company and we do not accept notices sent to our mailing address.</S.Paragraph>
      <S.Paragraph>Once we receive your DMCA notice, we will review it, make a determination on the infringement and notify you of the outcome in a timely manner. If we find that the DMCA requirements have been satisfied, we will remove the infringing content as quickly as possible.</S.Paragraph>
      
      <S.H5 level={2}>DMCA notice requirements</S.H5>
      <S.Paragraph>The DMCA notice must include the following:</S.Paragraph>
      <S.Tab>• A description of the copyrighted work you claim is being infringed or, if the claim involves multiple works, a representative list of such works.</S.Tab>
      <S.Tab>• A description of the material or link you claim is infringing (or the subject of infringing activity) and to which access is to be disabled, including at a minimum, if applicable, the URL of the link shown on the site or the exact location where such material may be found.</S.Tab>
      <S.Tab>• Adequate information by which we can contact you (your name, title, if acting as an agent, address, telephone number, and email address). Note portions or all the information you submit may be provided to third parties (e.g., the uploader of the material).</S.Tab>
      <S.Tab>• The following statement: “I have a good faith belief that the use of the copyrighted material I am complaining of is not authorized by the copyright owner, its agent, or the law (e.g., as a fair use)”.</S.Tab>
      <S.Tab>• The following statement: “The information in this notice is accurate and, under penalty of perjury, I am the owner, or authorized to act on behalf of the owner, of the copyright or of an exclusive right that is allegedly infringed”.</S.Tab>
      <S.TabEnd>• Provide your full legal name and your electronic or physical signature.</S.TabEnd>

      <S.Paragraph>Before you file your DMCA notice, please carefully consider whether or not the use of the copyrighted material at issue is protected by the Fair Use doctrine. If you file a DMCA notice when there is no infringing use, your request may be rejected. If you are unsure whether someone’s use of your copyrighted material amounts to infringement, please seek legal advice. You may also want to consult publicly available reference materials.</S.Paragraph>
      
      <S.H5 level={2}>Removal of Non-DMCA Content</S.H5>
      <S.Paragraph>If you uploaded a document containing sensitive or confidential information that you want removed then do not submit a DMCA notice. Your document will remain private and it will be removed automatically from our servers following the rules set out in the 
      <S.TextLink to={{ pathname: link + '/legal/file-retention-policy' }}>
      &nbsp;file retention policy
      </S.TextLink>
      .</S.Paragraph>
      <S.H5 level={2}>Other Disputes</S.H5>
      <S.Paragraph>Disputes regarding trademarks are not governed by the DMCA. These disputes must be resolved by the parties involved. We will never act as arbitrators or intermediaries in these disputes and will not take any action without appropriate legal orders.</S.Paragraph>
      </>
    );
  
    const mobileAndTabletLayout = (
      <Row gutter={[20, 24]}>
        <Col span={24}>
          
        </Col>
  
        <Col span={24}>
          
        </Col>
  
        <Col span={24}>
          
        </Col>
  
        <Col span={24}>
          
        </Col>
      </Row>
    );
  
    return (
      <>
        <PageTitle title={t('head:aboutUsTitle')} description={t('head:aboutUsDescription')} url='href' noIndex={true}></PageTitle>
        {isDesktop ? desktopLayout : mobileAndTabletLayout}
      </>
    );
  };

export default DMCAPolicyPage